import { c as _c } from "react/compiler-runtime";
import { QuestionMarkCircle } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { Button as RACButton, DialogTrigger as RACDialogTrigger } from 'react-aria-components';
import { Popover } from '~/components/Popover';
import { visuallyHidden } from '~/components/Utilities';
import type { RewardsBenefit } from './Rewards.types';
import styles from './RewardsBenefitRow.module.css';
interface RewardsBenefitRowProps {
  readonly benefit?: RewardsBenefit;
  readonly discount?: number;
}
export function RewardsBenefitRow(t0) {
  const $ = _c(20);
  const {
    benefit,
    discount
  } = t0;
  const t = useTranslations("account");
  const tAria = useTranslations("aria");
  if (!benefit) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <span aria-hidden="true" className={styles.placeholder}>—</span>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== tAria) {
      t2 = tAria("not_included");
      $[1] = tAria;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t2) {
      t3 = <li className={styles.row} data-test-id="RewardsBenefitRow">{t1}<span className={visuallyHidden}>{t2}</span></li>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t1;
  if ($[5] !== benefit.isDiscount || $[6] !== benefit.labelKey || $[7] !== discount || $[8] !== t) {
    t1 = benefit.isDiscount && discount !== undefined ? t(benefit.labelKey, {
      discount
    }) : t(benefit.labelKey);
    $[5] = benefit.isDiscount;
    $[6] = benefit.labelKey;
    $[7] = discount;
    $[8] = t;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const label = t1;
  let t2;
  if ($[10] !== benefit.isDiscount || $[11] !== label) {
    t2 = benefit.isDiscount ? <span className={styles.discount} data-test-id="RewardsBenefitDiscount">{label}</span> : <span className={styles.label}>{label}</span>;
    $[10] = benefit.isDiscount;
    $[11] = label;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== benefit.infoKey || $[14] !== label || $[15] !== t) {
    t3 = benefit.infoKey && <RACDialogTrigger><RACButton className={styles.infoTrigger} aria-label={t("rewards_benefit_info_label", {
        benefit: label
      })} data-test-id="RewardsBenefitInfo"><QuestionMarkCircle decorative={true} size="small" /></RACButton><Popover hasArrow={true} placement="top" maxWidth={260} ariaLabel={label}><p className={styles.popoverBody}>{t(benefit.infoKey)}</p></Popover></RACDialogTrigger>;
    $[13] = benefit.infoKey;
    $[14] = label;
    $[15] = t;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== t2 || $[18] !== t3) {
    t4 = <li className={styles.row} data-test-id="RewardsBenefitRow">{t2}{t3}</li>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}